import MuiButton, { ButtonProps as MuiButtonProps } from '@mui/material/Button'
import { useAuth } from 'hooks'
import { Link } from '../Link'

interface ButtonProps extends Omit<MuiButtonProps, 'href'> {
    can?: number | number[]
    href?: string | number
}

export function Button({ can: onlyView, href, ...props }: ButtonProps) {
    const {
        decoded: { categoria },
    } = useAuth()

    if (onlyView) {
        if (typeof onlyView === 'number' && onlyView !== categoria) {
            return null
        }

        if (Array.isArray(onlyView) && !onlyView.includes(categoria)) {
            return null
        }
    }

    if (href) {
        return (
            <MuiButton
                variant="contained"
                color="primary"
                {...props}
                component={Link as any}
                href={href as string}
            />
        )
    }

    return <MuiButton variant="contained" color="primary" {...props} />
}
